var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5607 2.06066L12.9393 0.439344C12.658 0.158039 12.2765 2.08024e-06 11.8787 0L6.5 0C5.67156 0 5 0.671562 5 1.5V3H2.5C1.67156 3 1 3.67156 1 4.5V14.5C1 15.3284 1.67156 16 2.5 16H9.5C10.3284 16 11 15.3284 11 14.5V13H13.5C14.3284 13 15 12.3284 15 11.5V3.12131C15 2.72349 14.842 2.34196 14.5607 2.06066ZM9.3125 14.5H2.6875C2.63777 14.5 2.59008 14.4802 2.55492 14.4451C2.51975 14.4099 2.5 14.3622 2.5 14.3125V4.6875C2.5 4.63777 2.51975 4.59008 2.55492 4.55492C2.59008 4.51975 2.63777 4.5 2.6875 4.5H5V11.5C5 12.3284 5.67156 13 6.5 13H9.5V14.3125C9.5 14.3622 9.48025 14.4099 9.44508 14.4451C9.40992 14.4802 9.36223 14.5 9.3125 14.5ZM13.3125 11.5H6.6875C6.63777 11.5 6.59008 11.4802 6.55492 11.4451C6.51975 11.4099 6.5 11.3622 6.5 11.3125V1.6875C6.5 1.63777 6.51975 1.59008 6.55492 1.55492C6.59008 1.51975 6.63777 1.5 6.6875 1.5H10V4.25C10 4.66422 10.3358 5 10.75 5H13.5V11.3125C13.5 11.3622 13.4802 11.4099 13.4451 11.4451C13.4099 11.4802 13.3622 11.5 13.3125 11.5ZM13.5 3.5H11.5V1.5H11.801C11.8507 1.5 11.8984 1.51975 11.9336 1.55491L13.4451 3.06641C13.4625 3.08382 13.4763 3.10449 13.4857 3.12724C13.4952 3.14999 13.5 3.17438 13.5 3.199V3.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.03477d55fe98e960279e81c46a6930cd.svg";
export { ForwardRef as ReactComponent };